// @flow
import { location } from "window";

import type { Error } from "error";

import TraceKit from "tracekit";

import url from "url";

import _ from "lodash";

import moment from "moment";

const observableServerTime = require("observable-server-time");

import TraceKitContextSubscriber from "./subscriber";

export default class NotificationTraceKitContextSubscriber extends TraceKitContextSubscriber {
	_errorCount: number = 0;
	_notificationTemplate: Object => string;

	constructor() {
		super();

		this._errorCount = 0;

		this._notificationTemplate = _.template(`
<% if (caseID) { %>
<div class="text-semibold">
	Расчет №
	<%- caseID %>
</div>
<% } %>

<% if (shouldSuggestPageReload) { %>
	<div class="margin-bottom-ms-0">
		<p class="margin-bottom-ms--4">
			Пожалуйста, обновите страницу, чтобы продолжить расчет.
		</p>
		<a
			href="<%= reloadPageLink %>"
			class="btn btn-xs btn-default"
		>
			Обновить страницу
		</a>
	</div>

<% } else if (userFriendlyMessages && userFriendlyMessages.length) { %>
		<% _.each(userFriendlyMessages, function (message) { %>
			<div>
				<%- message %>
			</div>
		<% }) %>

<% } else if (shouldSuggestReturningMuchLater) { %>
	<div>
		На этой странице произошла ошибка.
		Мы работаем над ее исправлением.
		Пожалуйста, закройте страницу и попробуйте вернуться к расчету позже.
	</div>


<% } else { %>
	<div>
		Что-то пошло не так, но не расстраивайтесь – попробуйте позднее.
	</div>
<% } %>

<% if (reportID) { %>
<div class="small">
	<span>
		Код ошибки:
		<%- reportID %>
	</span>

	<span style="margin-left: 0.5rem;">
		Время: 
		<%- calculatedServerTime %>
	</span>
</div>

<div style="margin-top:8px; font-size:14px; color:#fff;">
Обратитесь в 
<a href="https://www.rgs.ru/feedback?
reason=%D0%9B%D0%B8%D1%87%D0%BD%D1%8B%D0%B9%20%D0%BA%D0%B0%D0%B1%D0%B8%D0%BD%D0%B5%D1%82&
requestType=%D0%9E%D1%88%D0%B8%D0%B1%D0%BA%D0%B0%20%D0%BF%D1%80%D0%B8%20%D0%B2%D0%BD%D0%B5
%D1%81%D0%B5%D0%BD%D0%B8%D0%B8%20%D0%B8%D0%B7%D0%BC%D0%B5%D0%
BD%D0%B5%D0%BD%D0%B8%D0%B9%20%D0%B2%20%D0%9E%D0%A1%D0%90%D0%93%D0%9E"
target="_blank" rel="noopener"
style="color:#FFF; text-decoration:underline;">
техподдержку.
</a>
</div>
<% } %>
`);
	}

	onError(ctx: Object, error: Error) {
		if (!TraceKit.notifications) {
			return;
		}

		if (ctx._special_.quiet) {
			return;
		}

		this._errorCount += 1;

		let notifications = [];
		try {
			// TODO: prevent browserify bundling 'page-common' as a dependency for 'rgs-tracekit'
			// since it's only an optional dependency
			const page = require("page-common");
			notifications = page.notifications;
			if (!notifications) {
				return;
			}
		} catch (e) {
			return; // page module not loaded or broken or smth
		}

		const reportID = ctx._special_.id;
		const now = moment.utc().format("DD.MM.YYYY hh:mm ZZ");
		let calculatedServerTime =
			observableServerTime.ready().inspect().state === "fulfilled"
				? observableServerTime.serverTime()
				: moment();
		calculatedServerTime = calculatedServerTime.format(
			"HH:mm:ss [(][UTC]Z[)]"
		);
		const caseID = ctx["calc.common.caseID"];
		let userFriendlyMessages = ctx["error.userFriendlyMessages"];
		if (
			(ctx["error.name"] === "HttpError" &&
				(ctx["error.message"] === "Gateway Time-out" ||
					ctx["error.message"] === "Gateway Timeout")) ||
			ctx["error.name"] === "RemoteServiceTimeoutException"
		) {
			userFriendlyMessages = [
				"Мы не дождались ответа от сервера, попробуйте, пожалуйста, еще раз"
			];
		}
		const shouldSuggestPageReload =
			ctx["error.name"] === "ApiVersionException";
		const shouldSuggestReturningMuchLater = this._errorCount > 3;
		const reloadPageLink = url.format(
			_.defaultsDeep(
				{
					search: null,
					query: {
						noCache: moment().unix()
					}
				},
				url.parse(location.href, true)
			)
		);
		const style = shouldSuggestPageReload ? "success" : "danger";

		const html = this._notificationTemplate({
			reportID,
			caseID,
			now,
			userFriendlyMessages,
			shouldSuggestPageReload,
			shouldSuggestReturningMuchLater,
			reloadPageLink,
			calculatedServerTime
		});

		notifications.push({
			css: { [`notification-${style}`]: true },
			template: {
				html
			}
		});

		error.handled = {
			type: "notification",
			message: html
		};
	}
}
